<script lang='ts'>
    import { Icon, Input, InputGroup, Popover } from "sveltestrap"
    import type { Contain } from "../Model/Contain"
    import type { Param } from "../Model/Param"
    import { containsService, paramsService } from "../services"
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let params: Param[] = [];

    export let searchFilterComponent = {
        diligence : null,
        select : null,
        date : null
    };

    let inputDiligence = null;
    let select = null;
    let startDate = null;
    let endDate = null;
    
    let date = new Date();

    function load(searchFilter) {
        dispatch('load', searchFilter);
    }

    loadInputDate();
    loadTypes();

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    async function loadTypes() {
        params = await paramsService.findByType('diligencesTypes');
    }

    function loadData(data, type) {
        if (type == 'diligence') {
            searchFilterComponent.diligence = data;
        } else if (type == 'select') {
            searchFilterComponent.select = data;
        }else {
            searchFilterComponent.date = data;
        }
        load(JSON.stringify(searchFilterComponent));
    }

    function replaceDate() {
        let popover = document.getElementById('popoverCitation');
        popover.hidden = true;
        
        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function clearFilter() {
        searchFilterComponent = {
            diligence : null,
            select : null,
            date : null
        };
        inputDiligence = null;
        select = null;
        loadInputDate();
    }
</script>

<div class="container mt-3">
  <div class="row">
      <!-- Input para colocar el número del registro -->
      <div class="col-4 col-sm-4 mb-4">
          <form on:submit|preventDefault={() => loadData(inputDiligence,'diligence')}>
              <InputGroup>
                  <Input placeholder="Encuentra una diligencia" bind:value={inputDiligence} />
                  <button type="submit" class="btn btn-primary"><Icon name="search" /></button>
              </InputGroup>
          </form>
      </div>
      <!-- Select para el tipo -->
      <div class="col-4 col-sm-4 mb-4">
          <select bind:value={select} on:change={() => loadData(select, 'select')} class='form-select'>
              <option selected value={null}>Seleccionar tipo</option>
              {#each params as param}
                <option value={param.id}>{param.name}</option>
              {/each}
          </select>
      </div>
      <!-- Input para espcificar el rango de fechas para filtrar -->
      <div class="col-4 col-sm-4 mb-4 d-flex">
          
            <button class='btn border border-dark' id='popCitation'>
                {startDate} - {endDate}
            </button>
            <Popover placement="bottom" target="popCitation" id='popoverCitation'>
                <div id='startDate'>
                    <p>Desde:</p>
                    <Input
                        type='date'
                        bind:value={startDate}
                    />
                </div>
                <div id='endDate'>
                    <p>Hasta</p>
                    <Input
                        type='date'
                        bind:value={endDate}
                    />
                </div>
                <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
            </Popover>

          <button class='btn btn-primary ms-1' on:click={clearFilter}><Icon name='eraser' /></button>
      </div>
  </div>
</div>
